import cacheUtil, { CACHE_DEVICE_ID } from '@/utils/cache'

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

class Finger {
  deviceId = ''

  constructor() {
    this.init()
  }

  async init() {
    if (this.deviceId) {
      return
    }
    let deviceId = cacheUtil.get(CACHE_DEVICE_ID)
    if (!deviceId) {
      deviceId = guid()
      cacheUtil.set(CACHE_DEVICE_ID, deviceId)
    }
    this.deviceId = deviceId
  }
}

const fingerInstance = new Finger()

export default fingerInstance
